import { TACO0 } from "./TACO0";
import { TACOMAP } from "./TACOMAP";
import { TACOMENU } from "./TACOMENU";

export function TACOM () 
{
    return <div className="h-box">
        <TACOMENU />
        <TACOMAP />
    </div> 
}